//トップページ　キービジュアルスライダー
import slick from "slick-carousel";

export function idxFunc() {
  let indexPage = $("#indexTop").length;
  let resizecheck = $("#responsibleCheck").width();

  $(window).on("resize", function () {
    resizecheck = $("#responsibleCheck").width();
  });

  if (indexPage) {
    const wait = (ms) => new Promise((resolve) => setTimeout(() => resolve(), ms));

    //メインビュー
    wait(0).then(() => {
      $("#header .logoImg").addClass("active");
      $("#header .labelImg").addClass("active");
      return wait(600);
    });
   var slideStart = function () {
  $(".slideArea").each(function (i) {
    var $_t = $(this);
    let slideClass = $_t.addClass("slide" + i);

    if (resizecheck == "1") {
      $(".slideArea.slick-initialized").slick("unslick");
    } else {
      // Slick 初期化
      slideClass.not(".slick-initialized").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 400,
        slidesToShow: 1,
        arrows: true,
        dots: true,
        infinite: true,
        nextArrow: '<img src="/s/garrack/feature/chainsawman2025/images/product/product-next-arrow.svg" class="slide-arrow next-arrow">',
        prevArrow: '<img src="/s/garrack/feature/chainsawman2025/images/product/product-prev-arrow.svg" class="slide-arrow prev-arrow">',
      });

      const parentProduct = slideClass.closest(".product");
      const charas = parentProduct.find(".product__slide-chara");

      // 初期表示
      charas.removeClass("active").css("opacity", "0");
      charas.eq(0).addClass("active").css("opacity", "1");

      // スライド切替時
slideClass.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
  charas.removeClass("active").css("opacity", "0");
  charas.eq(nextSlide).addClass("active").css("opacity", "1");
});

      // ホバー演出（.productLinkLayer に対して）
      slideClass.find(".productLinkLayer").on("mouseenter", function () {
        const index = $(this).closest(".slide").index();

        // active なキャラだけ透明化
        charas.each(function () {
          if ($(this).hasClass("active")) {
            $(this).css("opacity", "0.7"); // 薄く
          } else {
            $(this).css("opacity", "0");   // 他は透明
          }
        });

        // 商品
        $(this).find(".productSlideImgBlock, .productSlideTxtBlock").css("opacity", "0.7");

      }).on("mouseleave", function () {
        // active なキャラ
        charas.each(function () {
          if ($(this).hasClass("active")) {
            $(this).css("opacity", "1");
          } else {
            $(this).css("opacity", "0");
          }
        });

        // 商品
        $(this).find(".productSlideImgBlock, .productSlideTxtBlock").css("opacity", "1");

        // ボタン
        $(this).find(".productBtn").css({
          paddingLeft: "",
          paddingRight: ""
        });
      });
    }
  });
};


    slideStart();
    // console.log("ageag");
    let setTimer = false;
    $(window).on("resize", function () {
      if (setTimer !== false) {
        clearTimeout(setTimer);
      }
      setTimer = setTimeout(() => {
        slideStart();
      }, 200);
    });
  }
}
